<template>
  <section id="assist__start">
    <h2>分享助力</h2>
    <div class="flex">
      <img src="https://cdn.anyteach.cn/img/assist/poster_mini.png" />
      <p>
        生成专属海报，
        <br />分享给好友扫码助力
      </p>
    </div>
    <div @click="start" class="btn-primary">
      <i class="anyteachicon anyteach-post"></i>
      <span>生成海报</span>
    </div>
    <div @click="to" class="btn-link">我的助力进度</div>
  </section>
</template>

<script>
import Toast from "mand-mobile/lib-vw/toast"

export default {
  name: "AssistStart",
  props: ["selectedRule"],
  methods: {
    start() {
      if (!this.$store.state.user.mobile) {
        return this.$emit("phone")
      }
      if (!this.selectedRule) {
        return this.$emit("choose")
      }
      this.$emit("poster")
    },
    to() {
      if (!this.$store.state.user.mobile) {
        return this.$emit("phone")
      }
      if (!this.selectedRule) {
        Toast({
          content: "还未参与活动，请先选择奖励",
          position: "bottom",
        })
        return this.$emit("choose")
      }
      this.$router.push(
        `/assist?ar_id=${this.selectedRule.id}&user_id=${this.$store.state.user.user_id}`,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

#assist__start {
  text-align: center;

  .flex {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 60%;
    margin: 0 auto 15px auto;
    padding: 20px 0;
    img {
      width: 80px;
      margin: 0 10px 0 0;
    }
  }
  p {
    text-align: left;
    font-size: 0.9rem;
  }
}
</style>
